"use client"
import React from "react";

import "@/components/market/management/VendorTags.css";

const VendorTags = ({ vendor, vendorTypesFlattened }) => {
  if (!vendor?.vendorProfile) return null;

  const { macroType, products } = vendor.vendorProfile;
  const macroTypeLabel = vendorTypesFlattened.find(
    type => type.value === macroType
  )?.label;

  const productLabel = product => {
    const productType = vendorTypesFlattened.find(
      type => type.value === product
    );
    return productType?.label || product;
  };

  return (
    <>
      <div className="vendor-tags tags" style={{ marginBottom: "0.5rem" }}>
        {macroType && (
          <span className={`tag macro-type ${macroType}`}>
            {macroTypeLabel || macroType}
          </span>
        )}
      </div>
      <div className="tags">
        {products && products.length > 0 && (
          <div className="vendor-products">
            {products.map((product, index) => (
              <span key={index}>{productLabel(product)}</span>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default VendorTags;
